import { createPortal } from 'react-dom'
import PropTypes from 'prop-types'
import React from 'react'

const RemoteHeader = ({ children }) => {
  const stickyHeadPosition = document.getElementById('sticky-head-position')

  return stickyHeadPosition
    ? createPortal(<>{children}</>, stickyHeadPosition)
    : null
}

RemoteHeader.propTypes = { children: PropTypes.element }

export default RemoteHeader
